import React, { Component } from "react";
import { Button, Col, Row } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import DraggableList from "react-draggable-list";
import cx from "classnames";
import "./main.css";
import { audioMessage as message } from "../../../Common/Notifications/audioMessage";
import { PermissionOverlay } from "../../../PermissionedComponents";

class PlanetItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
    };
  }

  _inc = () => {
    this.setState({ value: this.state.value + 1 });
  };

  getDragHeight = () => {
    return 47;
  };

  render() {
    const { item, itemSelected, dragHandleProps, handleDelete } = this.props;
    const { value } = this.state;
    const scale = itemSelected * 0.05 + 1;
    const shadow = itemSelected * 15 + 1;
    const dragged = itemSelected !== 0;

    return (
      <div
        className={cx("item", { dragged })}
        style={{
          transform: `scale(${scale})`,
          boxShadow: `rgba(0, 0, 0, 0.3) 0px ${shadow}px ${2 * shadow}px 0px`,
        }}
      >
        <div className="dragHandle" {...dragHandleProps} />
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="question-title">
            <h5 style={{ margin: 0 }}>{item.question}</h5>
          </div>
          <div>
            <Button
              shape="circle"
              size={"small"}
              onClick={() => {
                handleDelete(item.questionId);
              }}
              icon={<DeleteOutlined />}
            />
          </div>
        </div>
      </div>
    );
  }
}

class MySurvey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      useContainer: false,
      answerList: props.answersForQuestions,
    };
    this.container = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { answersForQuestions: prevAnswers } = prevProps;
    const { answersForQuestions: currentAnswers } = this.props;

    if (prevAnswers.length < currentAnswers.length) {
      // A question has been added
      message.success("Question added.");
    } else if (prevAnswers.length > currentAnswers.length) {
      // A question has been removed
      message.success("Question removed.");
    }

    if (prevAnswers !== currentAnswers) {
      this.setState({
        answerList: currentAnswers,
      });
    }
  }

  _onListChange = (newList) => {
    this.setState({ answerList: newList });
    // Pass the question IDs and new order to the parent
    this.props.onOrderChange(newList);
    message.success("Order Updated.");
  };

  handleDelete = (questionId) => {
    this.props.onDelete(questionId);
  };

  render() {
    const { useContainer, answerList } = this.state;

    return (
      <div className="main">
        <span>
          Drag and Drop the questions to change the order in which they will
          appear on the survey.
        </span>
        <PermissionOverlay
          permissionCheck="EditWellnessSurvey"
          tooltipMessage="You don't have permission to modify wellness survey questions"
        >
          <div
            className="my-survey-list"
            ref={this.container}
            style={{
              overflow: useContainer ? "auto" : "",
              height: useContainer ? "200px" : "",
              border: useContainer ? "1px solid gray" : "",
            }}
          >
            <DraggableList
              itemKey={(item) => item.questionId}
              template={(props) => (
                <PlanetItem {...props} handleDelete={this.handleDelete} />
              )}
              list={answerList}
              onMoveEnd={this._onListChange}
              container={() =>
                useContainer ? this.container.current : document.body
              }
            />
          </div>
        </PermissionOverlay>
      </div>
    );
  }
}

export default MySurvey;
